"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import CookieConsent from '@/components/CookieConsent';
import { shouldShowCookieBanner, acceptAllCookies, rejectAllCookies, acceptSelectedCookies, getCookiePreferences, CookiePreferences } from '@/utils/cookieConsent';
interface CookieConsentContextValue {
  preferences: CookiePreferences | null;
  showBanner: boolean;
  acceptAll: () => void;
  rejectAll: () => void;
  acceptSelected: (preferences: CookiePreferences) => void;
}
const CookieConsentContext = createContext<CookieConsentContextValue | undefined>(undefined);
interface CookieConsentProviderProps {
  children: ReactNode;
}
export function CookieConsentProvider(t0) {
  const $ = _c(16);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      showBanner: false,
      preferences: null,
      isHydrated: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [cookieState, setCookieState] = useState(t1);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const storedPreferences = getCookiePreferences();
      const shouldShow = shouldShowCookieBanner();
      setCookieState({
        showBanner: shouldShow,
        preferences: storedPreferences,
        isHydrated: true
      });
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const {
    showBanner,
    preferences,
    isHydrated
  } = cookieState;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      acceptAllCookies();
      setCookieState(_temp);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleAcceptAll = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      rejectAllCookies();
      setCookieState(_temp2);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleRejectAll = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = selectedPreferences => {
      acceptSelectedCookies(selectedPreferences);
      setCookieState(prev_1 => ({
        ...prev_1,
        preferences: {
          ...selectedPreferences,
          essential: true
        },
        showBanner: false
      }));
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleAcceptSelected = t6;
  let t7;
  if ($[6] !== preferences || $[7] !== showBanner) {
    t7 = {
      preferences,
      showBanner,
      acceptAll: handleAcceptAll,
      rejectAll: handleRejectAll,
      acceptSelected: handleAcceptSelected
    };
    $[6] = preferences;
    $[7] = showBanner;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const value = t7;
  let t8;
  if ($[9] !== isHydrated || $[10] !== showBanner) {
    t8 = isHydrated && showBanner && <CookieConsent onAccept={handleAcceptSelected} onReject={handleRejectAll} onAcceptAll={handleAcceptAll} />;
    $[9] = isHydrated;
    $[10] = showBanner;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== children || $[13] !== t8 || $[14] !== value) {
    t9 = <CookieConsentContext.Provider value={value}>{children}{t8}</CookieConsentContext.Provider>;
    $[12] = children;
    $[13] = t8;
    $[14] = value;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}
function _temp2(prev_0) {
  return {
    ...prev_0,
    preferences: {
      essential: true,
      analytics: false,
      marketing: false
    },
    showBanner: false
  };
}
function _temp(prev) {
  return {
    ...prev,
    preferences: {
      essential: true,
      analytics: true,
      marketing: true
    },
    showBanner: false
  };
}
export function useCookieConsent() {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error("useCookieConsent must be used within CookieConsentProvider");
  }
  return context;
}